// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LockTwoToneSvg from "@fishx/icons-svg/es/asn/LockTwoTone";
import FishxIcon from '../components/FishxIcon';

var LockTwoTone = function LockTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: LockTwoToneSvg
  }));
};

LockTwoTone.displayName = 'LockTwoTone';
export default React.forwardRef(LockTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/LockTwoTone.js
// module id = 3070
// module chunks = 0